module.exports = __webpack_public_path__ + "images/e287f9055e1ad222aacbacdc519243dd.svg";